
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ActionTypes } from '../actions/actionTypes';
import { saveWidgetsFailure, saveWidgetsSuccess, WidgetActions } from '../actions/widgetActions';
import { getUserWidgets, updateUserWidgets } from '../apis/userWidgets';
import { UserWidgets } from '../constants/online.homepagegateway.api';
import { buildInitWidgetLayout, buildNewLayouts, getReactGridLayoutArray, getWindowWidthInCurrentState, layoutsNotInDb, setCurrentLayout } from '../utilities/widgetHelper'
import { defaultWidgets } from '../constants/defaultWidgets';

export function* callGetWidgetsApi(action: WidgetActions) {
    try {
        const userWidgetsResponse: UserWidgets = yield call(getUserWidgets);
        const windowWidth: number = yield select(getWindowWidthInCurrentState);
        let userWidgets;

        if (userWidgetsResponse.widgetData.length == 0) {
            userWidgetsResponse.widgetData = defaultWidgets(windowWidth);
        }

        if (layoutsNotInDb(userWidgetsResponse.widgetData)) {
            userWidgets = buildNewLayouts(userWidgetsResponse.widgetData);
            yield call(updateUserWidgets, {widgetData: userWidgets});
        } else {
            userWidgets= buildInitWidgetLayout(userWidgetsResponse.widgetData, windowWidth);
        }
        userWidgets = setCurrentLayout(userWidgets, windowWidth);
        const gridLayout = getReactGridLayoutArray(userWidgets);
        yield put(saveWidgetsSuccess(userWidgets, gridLayout));
    }
    catch (error) {
        yield put(saveWidgetsFailure(error));
    }
}

export function* watchGetWidgets() {
    yield takeLatest(ActionTypes.GET_WIDGETS_INIT, callGetWidgetsApi);
}